// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","stickyContainer":"_1sFQ8mnkjhHwj7R8ZbSq5S","sideNavigationOpen":"_3W3JGCQxhoo2DxpBKLrZvP","adjustedMargin":"_3xjmg0TElWe9jK_lmFhslI"};